module.exports = __webpack_public_path__ + "img/bookmarks.890d60f6.svg";